module.exports = __webpack_public_path__ + "img/nature-44.238f0c70.jpg";